import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {PharmacyManagementSystemIntegrationStepsEnum} from '../../../interfaces/PharmacyManagementSystemIntegrationStepsEnum';
import {fadeInOut} from '../../../../shared/animations/animations';
import { Select, Store } from '@ngxs/store';
import { ProfileState } from 'src/app/shared/states/profile/profile.state';
import { Observable } from 'rxjs';
import { PharmacyState } from 'src/app/shared/states/pharmacy/pharmacy.state';
import {UntilDestroy} from '@ngneat/until-destroy';
import { IIntegrationConfiguration, IntegrationTypeEnum } from 'src/app/shared/interfaces/integration.interface';

@UntilDestroy()
@Component({
  selector: 'app-pms-integration-dialog',
  templateUrl: './pms-integration-dialog.component.html',
  styleUrls: ['./pms-integration-dialog.component.scss'],
  animations: [fadeInOut],
})
export class PharmacyManagementSystemIntegrationDialogComponent implements OnInit {
  @Input() show: boolean;
  @Input() progress: PharmacyManagementSystemIntegrationStepsEnum = PharmacyManagementSystemIntegrationStepsEnum.SelectType;
  //event handler inits stepper labels in parent
  @Output() integrationTypeSelected: EventEmitter<IntegrationTypeEnum> = new EventEmitter<IntegrationTypeEnum>();
  @Output() cancel: EventEmitter<void> = new EventEmitter();
  @Output() nextStep: EventEmitter<PharmacyManagementSystemIntegrationStepsEnum> = new EventEmitter();
  @Output() save: EventEmitter<any> = new EventEmitter();

  @Select(ProfileState.loading) loading$: Observable<boolean | undefined>;
  @Select(ProfileState.success) success$: Observable<boolean | undefined>;
  @Select(PharmacyState.currentPharmacy) currentPharmacy$: Observable<any>;

  PharmacyManagementSystemIntegrationStepsEnum = PharmacyManagementSystemIntegrationStepsEnum;
  next: any;
  connectionForm: any;
  alertMessage: { text: string, type: any };
  showMessage: boolean;

  IntegrationTypeEnum = IntegrationTypeEnum;

  @Input() selectedPmsType: IntegrationTypeEnum;
  selectedPmsValue: IIntegrationConfiguration;

  constructor(private store: Store) { }

  ngOnInit(): void {
    this.setPmsTypeAndPredefinedValue();
  }

  private setPmsTypeAndPredefinedValue(): void {
    if (isNaN(this.selectedPmsType) || this.selectedPmsType === null) {
      const firstIntegration = this.store.selectSnapshot(ProfileState.pharmacyManagementSystemIntegrations)[0]?.integrationType;
      if (firstIntegration !== null && firstIntegration !== undefined) {
        this.selectedPmsType = firstIntegration;
        this.selectedPmsValue = this.store.selectSnapshot(ProfileState.pharmacyManagementSystemIntegrations)?.find(x => x.integrationType === this.selectedPmsType);
        setTimeout(() => {  
          this.integrationTypeSelected.next(firstIntegration);
        });
      }
      
    } else {
      this.selectedPmsValue = this.store.selectSnapshot(ProfileState.pharmacyManagementSystemIntegrations)?.find(x => x.integrationType === this.selectedPmsType);
    }
  }

  integrationTypeSelectedHandler(type: IntegrationTypeEnum): void {
    this.selectedPmsType = type;
    this.selectedPmsValue = this.store.selectSnapshot(ProfileState.pharmacyManagementSystemIntegrations)?.find(x => x.integrationType === type);
    this.integrationTypeSelected.next(type);
  }

  setNextStep(step: PharmacyManagementSystemIntegrationStepsEnum | null): void {
    if (step === null) {
      this.cancel.emit();
      return;
    }

    this.progress = step;
    this.nextStep.emit(step);
  }
}
